<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
  >
    <path
      d="M5.58855 6.49702L0.293694 1.58244C0.200616 1.49647 0.126753 1.39425 0.0763498 1.28167C0.025947 1.16909 -5.22423e-07 1.04836 -5.27752e-07 0.926435C-5.33082e-07 0.804504 0.025947 0.683778 0.0763498 0.571196C0.126753 0.458613 0.200616 0.356398 0.293693 0.270425C0.482252 0.0971737 0.736767 -3.22051e-08 1.00198 -4.37982e-08C1.2672 -5.53912e-08 1.52172 0.0971736 1.71028 0.270425L7.70898 5.8366C7.89022 6.00562 7.99437 6.23302 7.99978 6.47152C8.00518 6.71003 7.91143 6.9413 7.73801 7.11725L1.71442 12.7269C1.52712 12.9014 1.27287 12.9996 1.0076 13C0.742327 13.0004 0.487765 12.9028 0.299915 12.7288C0.112064 12.5549 0.00631307 12.3187 0.00592417 12.0723C0.00553528 11.8258 0.110541 11.5894 0.297841 11.4149L5.58855 6.49702Z"
      fill="#213e7a"
    />
  </svg>
</template>

<script>
export default { name: "ArrowForward" };
</script>

<style></style>
